import { Heading } from '@efdigital/ll-addon-ui';
import { LinkTo } from '@ember/routing';

<template>
  <div class="container py-3">
    <Heading
      @size="lg"
      @text="Help and support"
      @secondary="Get help with the coaching platform and your account."
      @class="mb-4"
    />

    <ul>
      <li>
        <LinkTo @route="coaching.coachee.cohort.help.how-coaching-works">How
          coaching works here</LinkTo>
      </li>
    </ul>
  </div>
</template>
